import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import API from '../../api';
import AttendanceTable from '../smallComponent/AttendanceTable'; // Assume your attendance table is separated here

export default function EmployeeAttendanceReport() {
  const { id } = useParams();
  const [employee, setEmployee] = useState(null);
  const [attendances, setAttendances] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const token = localStorage.getItem('token');
  try {
    const res = await API.get(`/employees/${id}/attendance-report`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setEmployee(res.data.employee);
    setAttendances(res.data.attendances);
  }
    catch (err) {
      console.error('Failed to fetch attendance', err);
    }
  };

  if (!employee) return <div className="text-center mt-5">Loading...</div>;

  return (
    // <h1>hello</h1>
    <AttendanceTable employee={employee} attendances={attendances} />
  );
}
